
export default {
	props: {
		puzzleInfo: {
			type: Array,
			required: true,
		},
	},
};
